import HomePage from './pages/Home';
import CreateJobPage from './pages/CreateJob';
import {BrowserRouter as Router, Routes,Route} from 'react-router-dom'

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<HomePage/>} />
        <Route path='/addedit/:jobId?' element={<CreateJobPage/>} />
      </Routes>
    </Router>
  );
}

export default App;
